import Axios from "axios";
import {
  CheckerService_URL,
  ThirdPartyService_URL,
  WarehouseMumbaiService_URL,
} from "../redux/Url";
import {
  errorHandlerHelper,
  newAPIResponseHandler,
} from "../redux/responseDetection";
import axiosInstance from "./axiosInstance";
import { currentEnv } from "../constants";

// --------------- Fetch Packslip status API

export function fetchPSStatusThunk(props) {
  let { next } = props;
  const params = {};

  const apiUrl = `${CheckerService_URL}/packing/packer/status`;
  axiosInstance
    .get(apiUrl, { params })
    .then((response) => {
      return newAPIResponseHandler(response, next);
    })
    .catch((err) => {
      return newAPIResponseHandler(err, next);
    });
}

// --------------- Validate BOX  API

export function fetchPSValidateBoxThunk(props) {
  let { boxNumber, sourceBox, next } = props;
  const params = {
    boxNumber,
    sourceBox,
  };

  const apiUrl = `${CheckerService_URL}/packing/validate/box`;
  axiosInstance
    .get(apiUrl, { params })
    .then((response) => {
      return newAPIResponseHandler(response, next);
    })
    .catch((err) => {
      return newAPIResponseHandler(err, next);
    });
}

export async function generateInvoicePdf(props) {
  let { boxNumber } = props;

  const config = {
    params: {
      boxNumber,
    },
  };

  const apiUrl = `${CheckerService_URL}/packing/packslip`;

  try {
    const response = await axiosInstance.get(apiUrl, config);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error(
        response || `Request failed with status ${response.status}`
      );
    }
  } catch (error) {
    throw new Error(errorHandlerHelper(error) || "Failed to make request");
  }
}

export async function printPdfApi(props) {
  const config = {
    method: "POST",
    url: `https://api.printnode.com/printjobs`,
    data: props,
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Basic TnZtclExLVgyVGhsZjFaeTVqWE96NEtka0hUV1FWSjJyNm56TEl6ckZsdzo",
    },
  };

  // decoded access value : NvmrQ1-X2Thlf1Zy5jXOz4KdkHTWQVJ2r6nzLIzrFlw:

  try {
    const response = await Axios(config);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error(response);
    }
  } catch (error) {
    throw new Error(errorHandlerHelper(error));
  }
}
export const apiCallHandler = ({ method, url, params, data, next }) => {
  axiosInstance({
    method: method,
    url: url,
    data: data,
    params: params,
  })
    .then((response) => {
      next && next(response);
      return response;
    })
    .catch((err) => {
      return newAPIResponseHandler(err, next);
    });
};

export const newApiCallHandler = ({
  method,
  url,
  params,
  data,
  onSuccess,
  onFailure,
}) => {
  axiosInstance({
    method: method,
    url: url,
    data: data,
    params: params,
  })
    .then((response) => {
      newAPIResponseHandler && newAPIResponseHandler(response, onSuccess);
      return response;
    })
    .catch((err) => {
      const error = errorHandlerHelper(err);
      onFailure && onFailure(errorHandlerHelper(err));
      return error;
    });
};
